export enum SalesReportDateSelection {
  Issue = 'issue',
  Payment = 'payment',
}
